// extracted by mini-css-extract-plugin
export default {"container":"feedbackBlock_container__HnNyN","iconButton":"feedbackBlock_iconButton__R70-w","active":"feedbackBlock_active__c12jg","text":"feedbackBlock_text__BM4yV"};